import React from "react";
import withSvgIcon from "~/hocs/with-svg-icon";

export const CollapsedIcon = withSvgIcon(
    <path d="M295.1 108.1L446 259 295.6 409.4l-31.8-31.8L382.4 259 263.3 139.9zM85.8 108.1L236.7 259 86.3 409.4l-31.8-31.8L173.1 259 54 139.9z" />
);
